/**
 * レシピ著者詳細ページ
 */

import { breakpoint } from "../constant/breakpoint";
import { initProgressSlider } from "../util/sliderHelpers";

/**
 * 修正: レシピカード一覧・商品グリッドの VIEW MORE / VIEW LESS を初期化
 */
const initRecipeAuthorAccordion = (): void => {
  const accordions = document.querySelectorAll<HTMLElement>(
    "[data-recipe-author-accordion]",
  );

  for (const accordion of Array.from(accordions)) {
    const btn = accordion.querySelector<HTMLButtonElement>(
      "[data-recipe-author-accordion-btn]",
    );
    if (!btn) continue;

    btn.addEventListener("click", () => {
      const isExpanded = accordion.classList.contains("is-expanded");

      if (isExpanded) {
        accordion.classList.remove("is-expanded");
      } else {
        accordion.classList.add("is-expanded");
      }

      btn.setAttribute("aria-expanded", String(!isExpanded));
      const label = btn.querySelector<HTMLSpanElement>(
        "[data-recipe-author-accordion-label]",
      );
      if (label) {
        label.textContent = isExpanded ? "VIEW MORE" : "VIEW LESS";
      }
    });
  }
};

/**
 * 修正: キャンペーンスライダーを初期化（top-mv-sliderと同一UI）
 */
const initCampaignSlider = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(
    "[data-progress-slider='campaign-slider']",
  );

  if (sliders.length === 0) return;

  const splideInstances = initProgressSlider(
    "[data-progress-slider='campaign-slider']",
    "[data-progress-slider-pagination]",
    {
      type: "loop",
      perPage: 1,
      perMove: 1,
      gap: "3%",
      pagination: true,
      arrows: true,
      focus: "center",
      autoplay: false,
      speed: 800,
      rewindSpeed: 800,
      pauseOnHover: true,
      pauseOnFocus: true,
      autoWidth: true,
      breakpoints: {
        [Number.parseInt(breakpoint.md) - 1]: {
          gap: "7%",
          padding: { left: "16px", right: "16px" },
        },
      },
    },
  );

  splideInstances.forEach((splide, index) => {
    const slider = sliders[index];
    if (!slider) return;

    const updateActiveSlides = (activeIndex: number) => {
      const slides = slider.querySelectorAll(
        ".splide__slide",
      ) as NodeListOf<HTMLElement>;
      for (const slide of Array.from(slides)) {
        slide.classList.remove("is-active");
      }
      try {
        const activeSlide = splide.Components.Slides.getAt(activeIndex);
        if (activeSlide?.slide) {
          activeSlide.slide.classList.add("is-active");
        }
      } catch {
        const slideArray = Array.from(slides);
        const targetSlide = slideArray.find(
          (slide: HTMLElement, slideIndex: number) => {
            const dataIndex = slide.getAttribute("data-splide-index");
            return dataIndex
              ? Number.parseInt(dataIndex, 10) === activeIndex
              : slideIndex === activeIndex;
          },
        );
        if (targetSlide) {
          targetSlide.classList.add("is-active");
        } else if (slideArray[activeIndex]) {
          slideArray[activeIndex].classList.add("is-active");
        }
      }
    };

    updateActiveSlides(splide.index);

    splide.on("move", (newIndex) => {
      updateActiveSlides(newIndex);
    });

    splide.on("moved", (newIndex) => {
      updateActiveSlides(newIndex);
    });
  });
};

export function recipeAuthor(): void {
  if (!document.body.classList.contains("template-page--recipe-author")) {
    return;
  }

  initRecipeAuthorAccordion();
  initCampaignSlider();
}
